<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    // Dynamically load emoji-picker-element only once
    if (!window.emojiPickerLoaded) {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = 'https://cdn.jsdelivr.net/npm/emoji-picker-element@^1/index.js';
      document.head.appendChild(script);
      window.emojiPickerLoaded = true;
    }
  }
}
</script>